export default __webpack_public_path__ + "static/media/Spinner-1.9s-204px.620537f0.svg";